module.exports = __webpack_public_path__ + "media/mypage/images/arrows-0c981a9227cfe7c87c8016f0818853f0.png";